var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L7 7L13 1","stroke":"#fff","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowDownInline.defaultProps = {"width":"14","height":"8","viewBox":"0 0 14 8","fill":"none"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
